import type { Components, ThemeOptions } from "@mui/material";

declare module "@mui/material/TextField" {
  interface TextFieldPropsSizeOverrides {
    large: true;
  }
}

export const MuiTextField: Components<ThemeOptions>["MuiTextField"] = {};
